
import { createSelector } from 'reselect'

const innerStateSelector = state => state.siteDesigner;

const pagesListSelector = createSelector(
   innerStateSelector,
   state => state.pagesList
);

const leftSideFetchingSelector = createSelector(
   innerStateSelector,
   state => state.leftSideFetching
);
const rightSideFetchingSelector = createSelector(
   innerStateSelector,
   state => state.rightSideFetching
);
const selectedPagesStateSelector = createSelector(
   innerStateSelector,
   state => state.selectedPagesState
);

const fetchPublishDraftContentSelector = createSelector(
   innerStateSelector,
   state => state.fetchPublishDraftContent
);

const currentPageSelector = createSelector(
   innerStateSelector,
   state => state.currentPage
);
const fetchSaveAsDraftSelector = createSelector(
   innerStateSelector,
   state => state.fetchSaveAsDraft
);
const pageSectionsSelector = createSelector(
   innerStateSelector,
   state => state.pageSections
);
const currentSectionUuidSelector = createSelector(
   innerStateSelector,
   state => state.currentSectionUuid
);
const globalSettingsSelector = createSelector(
   innerStateSelector,
   state => state.globalSettings
);
const reservGlobalSettingsSelector = createSelector(
   innerStateSelector,
   state => state.reservGlobalSettings
);
const currentSegmentSelector = createSelector(
   innerStateSelector,
   state => state.currentSegment
);
const contentResourcesSelector = createSelector(
   innerStateSelector,
   state => state.contentResources
);
const reservPageSectionsSelector = createSelector(
   innerStateSelector,
   state => state.reservPageSections
);
const savedDataSelector = createSelector(
   innerStateSelector,
   state => state.savedData
);
const siteColorsSelector = createSelector(
   innerStateSelector,
   (state) => {
      let colors = []
      const globalColors = state?.globalSettings?.color || {};
      Object.keys(globalColors).forEach(key => {
         const color = globalColors[key];
         if(color?.primary_color){
            colors = [
               ...colors,
               color.primary_color,
            ]
         }
      })
      return colors
   }
);

const prepearComponentForRenderSelector = createSelector(
   innerStateSelector,
   state => state.prepearComponentForRender
);
const rightSideSelector = createSelector(
   innerStateSelector,
   state => state.rightSide
);
export {
   pagesListSelector,
   selectedPagesStateSelector,
   fetchPublishDraftContentSelector,
   rightSideFetchingSelector,
   leftSideFetchingSelector,
   currentPageSelector,
   fetchSaveAsDraftSelector,
   pageSectionsSelector,
   currentSectionUuidSelector,
   globalSettingsSelector,
   siteColorsSelector,
   reservGlobalSettingsSelector,
   currentSegmentSelector,
   contentResourcesSelector,
   reservPageSectionsSelector,
   savedDataSelector,
   prepearComponentForRenderSelector,
   rightSideSelector,
}
